import type { CSSProperties } from 'react';

/** Chart series palette. Never black or gray. Mirrors --chart-1…6 in styles.css. */
export const CHART_COLORS = [
  'var(--chart-1)',
  'var(--chart-2)',
  'var(--chart-3)',
  'var(--chart-4)',
  'var(--chart-5)',
  'var(--chart-6)',
] as const;

export function chartColor(i: number): string {
  return CHART_COLORS[i % CHART_COLORS.length] ?? CHART_COLORS[0];
}

/** Recharts `Tooltip contentStyle` that matches the card chrome. */
export const CHART_TOOLTIP: CSSProperties = {
  background: 'var(--surface)',
  border: '1px solid var(--border)',
  borderRadius: 10,
  fontSize: 12,
  color: 'var(--text)',
  boxShadow: 'var(--shadow-pop)',
  padding: '8px 10px',
};

/** Recharts axis tick style. */
export const CHART_TICK = { fontSize: 11, fill: 'var(--text-subtle)' } as const;

/** Recharts bar hover cursor. */
export const CHART_CURSOR = { fill: 'var(--surface-hover)' } as const;
